export default __webpack_public_path__ + "static/media/left-arrow-from-left.cc51443c.svg";